// src/features/agent-builder/components/ContextWeaverNote.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Zap } from 'lucide-react';
import clsx from 'clsx';

export const ContextWeaverNote: React.FC = () => {
  const { t } = useTranslation('agentBuilder');

  return (
    <div className="relative group mt-6 cursor-default"> {/* cursor-default if not clickable */}
      {/* Shadow Element - Appears on hover */}
      <div
        className={clsx(
          "absolute inset-0 rounded-lg bg-black",
          "transition-transform duration-150 ease-out", // Transition for smooth appearance
          // Initially no translation, or opacity-0 if you want it completely hidden
          // "opacity-0 group-hover:opacity-100", // Alternative: fade in shadow
          "group-hover:translate-x-px group-hover:translate-y-px" // Shadow translates into view
        )}
        aria-hidden="true"
      />

      {/* Content Element - Lifts on hover */}
      <div
        className={clsx(
          "relative p-4 bg-slate-100 rounded-lg",
          "border-2 border-black",
          "transition-transform duration-150 ease-out", // Transition for smooth lift
          "group-hover:-translate-x-px group-hover:-translate-y-px" // Content lifts
        )}
      >
        <div className="flex items-center gap-3">
          <Zap size={22} className="text-teal-600 shrink-0" aria-hidden="true" />
          <p className="text-sm font-medium text-slate-700">
            <span
              dangerouslySetInnerHTML={{
                __html: t('step2.contextWeaver.note'),
              }}
            />
          </p>
        </div>
      </div>
    </div>
  );
};